
import { Component, OnInit, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import {ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common'

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake  from 'pdfmake/build/pdfmake.js';
// import pdfFonts from 'pdfmake/build/vfs_fonts.js';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'app-viewapplicationstatus',
  templateUrl: './viewapplicationstatus.component.html',
  styleUrls: ['./viewapplicationstatus.component.scss']
})

export class ViewapplicationstatusComponent implements OnInit {
  
  @ViewChild('agGrid') agGrid!: AgGridAngular;
  studData:any;
  application_type_requested:any;
  rowData:any;
  pagination:any
  noapplication!: boolean;
  Requestform: any;
  photolink: any;
  marksheetlink: any;
  saluation: any;
  stud_name: any;
  standard: any;
  mobile_no: any;
  email_address: any;
  address: any;
  pincode: any;
  passing_month_year: any;
  seat_no: any;
  school_name: any;
  exam_month_year: any;
  allowRePay!:boolean;
  paymenturl: any;
  transid: any;
  totalpay:any;
  paymentresponcemsg: any;
  studexamname!: any;
  applicationid: any;
  detailRowHeight:any=500;
  idprroflink: any;
  schoolrecletterlink: any;
  zonalletterlink: any;
  lcregicopylink: any;
  request_status_remark: any;
  application_status_remark: any;
  msg: any;
  showMainContent: Boolean = true;
  paymentmode!: string;
  paymentstatus: any;
  selectedPaymentMode: any;
  isChecked2!: boolean;
  isChecked!: boolean;
  request_status: any;
  application_status: any;
  ctx: any;
  constructor( private service:UserserviceService ,public router: Router,private httpClient: HttpClient,private route: ActivatedRoute,private formBuilder: FormBuilder,public datepipe: DatePipe) { }
  public columnDefs: (ColDef | ColGroupDef)[] = [
    {headerName: 'Application No.',field:'application_id', width: 160, sortable: true, filter: true,sort: 'desc'  },
    {headerName: 'Student Name',field:'stud_name', sortable:true, filter:true,width: 250},
    {headerName: 'Standard',field:'standard', sortable:true,filter:true,width: 120},
    {headerName: 'Application For',field:'application_type', sortable:true,filter:true,width: 200},
    {headerName: 'Submitted On',field:'application_create_date', sortable: true, filter: true,width: 150}, 
    {headerName: 'Request Status',field: 'request_status', sortable: true, filter: true,width: 150},
    {headerName: 'Application Status',field: 'application_status', sortable: true, filter: true,width: 150},
    {headerName: 'Payment Status',field: 'payment_status', sortable: true, filter: true,width: 150},
    {field: 'View', sortable:true,width: 90, filter: true,cellRenderer : function(params: any){
      return '<div><button  class="btn btn-outline-primary btn-sm btnEdit" data-bs-toggle="modal" href="#candidateprofile"><i  class="bi bi-eye-fill tblbtn"></i></button></div>'
      },
    },
    {field: 'Print', sortable:true,width: 90, filter: true,cellRenderer : function(params: any){
      return ' <div> <button  class="btn btn-outline-primary btn-sm btnEdit" > <i  class="bi bi-printer-fill tblbtn" data-bs-toggle="modal" href="#applicationpdf" ></i> </button> </div>'
      },
    },
    {field: 'Pay', sortable:true, width: 90, filter: true,cellRenderer : function(params: any){
      return '<div><button class="btn btn-outline-primary btn-sm btnEdit" data-bs-toggle="modal" href="#paymentmodal"><i class="bi bi-cash-coin"></i></button></div>'
      },
    }
 
];
public defaultColDef: ColDef = {
  // set the default column width
  // width: 150,
  // make every column editable
 
  // make every column use 'text' filter by default
  filter: 'agTextColumnFilter',
  // enable floating filters by default
  
  // make columns resizable
  resizable: true,
};



  ngOnInit(): void {
    if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
      this.router.navigate(['/Login']);
    }
    
    this.getStudDetail();
    this.Requestform = this.formBuilder.group({
      // saluation:['',Validators.required],
      stud_name:['',Validators.required],
      standard:['',Validators.required],
      mobile_no:['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],     
      email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      address:['',Validators.required],
      pincode:[''],
      exam_month_year:['',Validators.required],
      passing_month_year:['',Validators.required],
      seat_no:['',Validators.required],
      school_name:['',Validators.required],
      upload_photo:['',Validators.required],
      upload_marksheet:['',Validators.required],  
    });

    // this.rowData = [
    //   {ApplicationID: '1',Name:'ajay shah',  CreatedOn: '20/11/2022', InstitudeCode:'78863863867893', AcademicYear:'2021-2022', CourseCode:'SBI12346789',BranchName:'goa',ApplicationStatus:'pending'},
      
    // ];
    };
    get migration(){
      return sessionStorage.getItem('loggedapptype')=="Fresh_Migration_Certificate";
    }
    get duplicatemarksheetpassing(){
      return sessionStorage.getItem('loggedapptype')=="Duplicate_Marksheet" || sessionStorage.getItem('loggedapptype')=="Duplicate_Passing_Certificate";
    }
    get changerequest(){
      return sessionStorage.getItem('loggedapptype')=="Change_Request_On_Marksheet" || sessionStorage.getItem('loggedapptype')=="Change_Request_On_Passing_Certificate";
    }
    onBtExport() {
      this.agGrid.api.exportDataAsCsv();
    }
    
    getStudDetail(){
      let getstud:{ user_id:any,email_address:any}={
        user_id: sessionStorage.getItem('loggeduserid'),
        email_address: sessionStorage.getItem('loggeduser')
  
      };
        this.service.post('/Student_module/getregistration',getstud).subscribe((res:any)=>{
        //  console.log(res);
        if(res.status=="success"){
            if(res.Data[0].request_status!="New"){
              this.rowData=[res.Data[0]]; 
              this.studData=res.Data[0]; 
              this.pagination=true;
              this.application_type_requested=res.Data[0].standard+" - "+res.Data[0].application_type;
              this.totalpay=res.Data[0].total_payment;
              this.paymentstatus=res.Data[0].payment_status;
              switch(this.studData.pay_using){
                  case '4': this.paymentmode="Debit Card";break;
                  case '5': this.paymentmode="Credit Card";break;
                  case '3': this.paymentmode="Net Banking";break;
                  case '6': this.paymentmode="UPI";break;
              }
          
            }    
           else{
              this.rowData=[];
              this.noapplication=true;
           }
         
        }
          else{
            this.studData="";
            // alert("Please try again!")
            this.router.navigate(['/dashboard']);
          }
          if(this.studData){
            this.applicationid=this.studData.application_id;
            this.stud_name=this.studData.stud_name;
            this.standard=this.studData.standard;
            this.mobile_no=this.studData.mobile_no;
            this.email_address=this.studData.email_address;
            this.address=this.studData.address;
            this.pincode=this.studData.pincode;
            // this.passing_month_year=this.studData.passing_month_year;
            this.exam_month_year=this.studData.exam_month_year;
            this.seat_no=this.studData.seat_no;
            this.school_name=this.studData.school_name;
            // this.Requestform.controls['upload_photo=this.studData.upload_photo);
            // this.Requestform.controls['upload_marksheet=this.studData.upload_marksheet)
            this.photolink=this.studData.upload_photo;
            this.marksheetlink=this.studData.upload_marksheet;
            this.idprroflink=this.studData.upload_idproof;
            this.schoolrecletterlink=this.studData.upload_schoolrecomendation_letter;
            this.zonalletterlink=this.studData.upload_zonal_permission_letter;
            this.lcregicopylink=this.studData.upload_lc_register_copy;
            this.request_status=this.studData.request_status;
            this.request_status_remark=this.studData.request_status_remark;
            this.application_status=this.studData.application_status;
            this.application_status_remark=this.studData.application_status_remark;
            this.isrepayallowed();//checking if re payment to be allowed or not...

            }    
        });
      //get student deatils in studData variable
      
  }

  openmodal(mdl:any){
      let testmodal=document.getElementById(mdl);
      testmodal?.style.setProperty("display","block");
  }
  closemodal(mdl:any){
      let testmodal=document.getElementById(mdl);
      testmodal?.style.setProperty("display","none");
  }
  getstuddataonform(){
    // alert(111);
  }
  isrepayallowed(){
      if(this.studData.payment_status!="Paid"){
          this.allowRePay=true;
          this.paymentresponcemsg="";
          this.paymentresponcemsg=this.studData.payment_status_remark;        
        }
        else{
          this.allowRePay=false;  
          this.paymentresponcemsg=this.studData.payment_status_remark;        
      }
  }
  async generateapplicationPdfformigration(e:any){
    this.msg=e
   //alert(this.msg);
   if(this.msg=='Unpaid')
   {
    this.showMainContent = this.showMainContent ? false : true;
    // alert("Please make payment to download PDF");
    setTimeout(()=>{ 
           window.location.reload();
      },2000); 
   }
   else{
              if(this.studData.standard=="HSSC"){
                    this.studexamname="Higher Secondary";
              }
              else if(this.studData.standard=="SSC"){
                    this.studexamname="Secondary";          
              }
            if(sessionStorage.getItem('loggedapptype')=="Change_Request_On_Marksheet" || sessionStorage.getItem('loggedapptype')=="Change_Request_On_Passing_Certificate"){
                    const documentDefinition = { 
                      header: [
                        // margin: [5, 0, 0, 10],
                        // columns: [
                          
                        // ]
                        {
                          image: await this.getBase64FromUrl('assets/img/board_logo.png'),
                         
                          width: 50,
                          height: 50,
                          margin: [0, 10, 0, 7] ,
                          alignment: 'center',
                        }    
                      ],    
                      content: [
                        {  //text: 'Application For '+ sessionStorage.getItem('loggedapptype')?.replace(/_+/g," "), 
                            text: 'Acknowledgement', 
                              bold: true,
                              fontSize: 22,
                              alignment: 'center',
                              margin: [0, 20, 0, 7]
                        },
                        {
                          text: '..................................................................................................................................................................................................................' ,
                          // bold: true,
                          fontSize: 9,
                          // alignment: 'center',
                          margin: [0, 10, 0, 7]
                        },
                        {
                          text: 'Date: '+this.datepipe.transform(new Date(), 'dd-MM-yyyy'),
                          fontSize: 12,
                          alignment: 'right',
                          margin: [5, 15, 5, 10]
                        },                       
                        {
                          text: 'Request for issuing '+sessionStorage.getItem('loggedapptype')?.replace(/_+/g," "),
                          bold: true,
                          fontSize: 14,
                          alignment: 'center',
                          lineHeight:2,
                          margin: [5, 0, 0, 0]
                        },
                        {
                          text: 'Application Id:  '+this.studData.application_id,
                          fontSize: 12,
                          alignment: 'left',
                          margin: [5, 0, 0, 0]
                        },
                        {
                          text: 'Payment Status:  '+this.studData.payment_status,
                          fontSize: 12,
                          alignment: 'left',
                          margin: [5, 0, 0, 0]
                        },
                         {
                          text: 'Amount Paid:  Rs. '+this.studData.total_payment,
                          fontSize: 12,
                          alignment: 'left',
                          margin: [5, 0, 0, 0]
                        },
                         {
                          text: 'Transaction Id:  '+this.studData.transaction_id,
                          fontSize: 12,
                          alignment: 'left',
                          margin: [5, 0, 0, 0]
                        },
                        // {
                        //   text: 'Respected Sir/Madam,',
                        //   // bold: true,
                        //   fontSize: 14,
                        //   alignment: 'left',
                        //   lineHeight:2,
                        //   margin: [5, 15, 5, 10]
                        // },
                        // {text: 'To,', style:'para1'},
                        // {text: 'The Secretary', style:'para1'},
                        // {text: 'Goa Board of Secondary &', style:'para1'},
                        // {text: 'Higher Secondary Education', style:'para1'},
                        // {text: 'Alto Betim - Goa 403 521', style:'para1'},
                        // {
                        //   text: '\u200B\t\t\t I '+ this.studData.stud_name+' request you to please accept application for '+sessionStorage.getItem('loggedapptype')?.replace(/_+/g," ") +',',
                        //   // bold: true,
                        //   // fontSize: 14,
                        //   // // alignment: 'center',
                        //   // lineHeight:2,
                        //   margin: [5, 15, 5, 10],
                        //   style:'para1'
                        // },
                        // {
                        //   text: '\u200B\t\t\t I have filled online form, and have paid fees for the same. All the nessesary documents are hereby attached with the same, (and uploaded)',
                        //   // // bold: true,
                        //   // fontSize: 14,
                        //   // // alignment: 'center',
                        //   // lineHeight:2,
                        //   // margin: [5, 15, 5, 10]
                        //   style:'para1'
                        // },
                        {text: 'Requested Changes are as below: ', style: 'subheader',fontSize: 12, margin: [5, 15, 5, 10]},
                        {
                          fontSize: 12,
                          style: 'tableExample',
                          table: {
                            body: [
                              ['Discrepancy Found', 'Old Data', 'Correction To be done as per School General Register'],
                              ['First Name', this.studData.original_first_name, this.studData.new_first_name],
                              ['Father\'s Name', this.studData.original_father_name, this.studData.new_father_name],
                              ['Mother\'s Name', this.studData.original_mother_name, this.studData.new_mother_name],
                              ['Date Of Birth', this.studData.original_dob, this.studData.new_dob],
                            ]
                          },
                          margin: [5, 15, 5, 10]
                        },
                        
                        // {
                        //   text: '\u200B\t\t\t I also wish to state that I have cleared all my dues and payments. ',
                        //   // bold: true,
                        //   fontSize: 14,
                        //   // alignment: 'center',
                        //   margin: [5, 15, 5, 10]
                        // },
                        {text: 'The following documents are attached herewith acknowledgement:', style:'para13'},
                        {text: 'a) An attested copy of Valid Identity Proof', style:'para3'},
                        {text: 'b) An attested copy of Zonal permission letter', style:'para3'},
                        {text: 'c) Request letter from school', style:'para3'},
                        {text: 'd) An attested copy ofLeaving Certificate', style:'para3'},
                        {text: 'e) Statement of Marks/ Passing Certificate', style:'para3'},
                        // {
                        //   text: '\u200B\t\t\t\t\t Thanking you advance!',
                        //   // bold: true,
                        //   fontSize: 14,
                        //   // alignment: 'center',
                        //   lineHeight:2,
                        //   margin: [5, 15, 5, 10]
                        // },
                        // {
                        //   text: 'Signature',
                        //   // bold: true,
                        //   fontSize: 14,
                        //   alignment: 'right',
                        //   lineHeight:2,
                        //   margin: [5, 75, 5, 10]
                        // },
                        // {
                        //   text: '\u200B\t\t\tThis is to certify that '+ this.studData.stud_name+', Examination Seat No. '+this.studData.seat_no+'   has passed the '+ this.studexamname+' School Certificate Examination held by this Board in '+this.studData.exam_month_year+ '.',
                        //    // bold: true,
                        //   fontSize: 14,
                        //   // alignment: 'center',
                        //   lineHeight:2,
                        //   margin: [5, 25, 5, 10]
                        // },
                        // {
                        //   text: '\u200B\t\t\tThere is no objection to the candidate\'s joining an institution recognised by the Board or affiliated to a University.' ,
                        //    // bold: true,
                        //   fontSize: 14,
                        //   // alignment: 'center',
                        //   lineHeight:2,
                        //   margin: [5, 15, 5, 10]
                        // },        
                      ],

                      styles :{
                        table1:{
                          fontSize:12,
                          alignment:'right',
                        },
                        para1:{
                          fontSize: 14,
                          alignment: 'left',
                          lineHeight:1,
      
                        },
                        para13:{
                          fontSize: 14,
                          alignment: 'left',
                          lineHeight:1.3,
      
                        },
                        para3:{
                          fontSize: 12,
                          alignment: 'left',
                          lineHeight:1.3,
      
                        },
                        para2:{
                          fontSize: 12,
                          alignment: 'left',
                          bold:true,
                        },
                        foot:{
                          fontSize: 11,
                          alignment: 'left',
                          lineHeight:1,
      
                        },
                        table2:{
                          fontSize:14,
                        },
                      }
                    };
                   // (pdfMake as any).createPdf(documentDefinition).open();
                    (pdfMake as any).createPdf(documentDefinition).print();
                    // (pdfMake as any).createPdf(documentDefinition).download('Application_Letter of '+ this.studData.stud_name+'.pdf');
            }


          //edited start by renuka
            else if(sessionStorage.getItem('loggedapptype')=="Fresh_Migration_Certificate"){
              const documentDefinition = { 
                // header: {
                //   margin: [5, 0, 0, 10],
                //   columns: [
                //     {  text: 'Acknowledgement', 
                //         bold: true,
                //         fontSize: 22,
                //         alignment: 'center',
                //         margin: [0, 10, 0, 7]
                //     }
                //   ]
                // }, 
                  
                content: [
                  // { 
                  //   columns :[
                  //       [
                  //         {   
                  //           layout: 'noBorders',  
                  //           style:'table1',  
                  //           table: {
                  //             widths: [400, 700],
                  //             body: [
                  //               [{text:"From :"}],
                  //               [{text:"Name :"}],
                  //               [{text:"Address :"}] 
                  //             ]
                  //           },
                            
                  //           },
                          
                        
                  //     ]
                  //   ],           
                  //       pageSize: 'A4',
                  //       pageOrientation: 'portrait',
                  //       pageMargins: 20
                  //   },
                  
                  {
                    text: 'Date: '+this.datepipe.transform(new Date(), 'dd-MM-yyyy'),
                    fontSize: 12,
                    alignment: 'right',
                    margin: [5, 15, 5, 10]
                  },
                  {text: 'To,', style:'para1'},
                  {text: 'The Secretary,', style:'para1'},
                  {text: 'Goa Board of Secondary &', style:'para1'},
                  {text: 'Higher Secondary Education', style:'para1'},
                  // {text: 'Alto Betim - Goa 403 521', style:'para1'},
                  {
                    text: 'ISSUE OF MIGRATION CERTIFICATE',
                    bold: true,
                    fontSize: 14,
                    alignment: 'center',
                    lineHeight:2,
                    margin: [5, 15, 5, 10]
                  },
                  // {text: 'Sir', style:'para2'},
                  {
                    text: 'Sir/Madam, ',
                    // bold: true,
                    fontSize: 12,
                    // alignment: 'center',
                    lineHeight:1,
                    margin: [0, 0, 5, 10]
                  },
                  {
                    text: '\u200B\t\t\t I the undersigned Shri./Kum. '+ this.studData.stud_name+' hereby request you to issue me Migration Certificate.\n My Details are as given below :',
                    // bold: true,
                    fontSize: 12,
                    // alignment: 'center',
                    lineHeight:1,
                    margin: [0, 0, 5, 10]
                  },
                  {
                    text: 'Application Id:  '+this.studData.application_id,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  {
                    text: 'Payment Status:  '+this.studData.payment_status,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  {
                    text: 'Amount Paid:  Rs. '+this.studData.total_payment,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  {
                    text: 'Transaction Id '+this.studData.transaction_id,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  { 
                    layout: 'noBorders',
                    table: {
                      style:'table2',
                      widths: [250, 300],
                      //heights: [20, 20, 20,20,20,],
                      margin: [0, 5, 0, 0],
                      body: [
                        [{text:"1. Full Name",margin: [0, 5, 0, 0]},{text:this.studData.stud_name.toUpperCase( ) ,margin: [0, 5, 0, 0]}],
                        // [{text:"(begining with surname block letters)",margin: [7, 2, 0, 0]},{text:'',margin: [7, 2, 0, 0]}],
                        [{text:"2. Month & Year of passing the Examination",margin: [0, 7, 0, 0]},{text:this.studData.exam_month_year,margin: [0, 5, 0, 0]}],
                        [{text:"3. Name Of Examination",margin: [0, 7, 0, 0]}, {text: this.studData.standard,margin: [0, 5, 0, 0]}],
                        [{text:"4. Seat Number",margin: [0, 7, 0, 0]}, {text:this.studData.seat_no ,margin: [0, 7, 0, 0]}],
                        [{text:"5. School Index",margin: [0, 7, 0, 0]}, {text: this.studData.school_name,margin: [0, 5, 0, 0]}],
                        [{text:"6. Centre",margin: [0, 7, 0, 0]},{text:this.studData.exam_center,margin: [0, 5, 0, 0]}],
                        // [{text:"7. Name Of Board",margin: [0, 7, 0, 0]},{text:': _______________________________'}],
                        // [{text:"8. SCODE of the institution that sponsored the",margin: [0, 7, 0, 0]},{text:this.studData.school_name,margin: [0, 5, 0, 0]}],
                        // [{text:"candidate for above examination",margin: [7, 2, 0, 0]},{text:'',margin: [7, 2, 0, 0]}],
                        // [{text:"7. Payment Status",margin: [0, 7, 0, 0]},{text:this.studData.payment_status,margin: [0, 5, 0, 0]}],
                        [{text:"7. Mode of payment and the relavent",margin: [0, 7, 0, 0]},{text:this.paymentmode,margin: [0, 5, 0, 0]}],
                        [{text:"number of receipt / M. 0. etc.",margin: [7, 2, 0, 7]},{text:this.studData.transaction_id,margin: [0, 5, 0, 0]}]
                      ]
                    },
                    pageSize: 'A4',
                      pageOrientation: 'portrait',
                      pageMargins: 20
                    
                    },
                    {text: 'The following documents are attached herewith:', style:'para13'},
                    // {text: 'a) An attested copy ofLEAVING CERTIFICATE', style:'para3'},
                    {text: 'a) Passport Sized Photo', style:'para3'},
                    {text: 'b) An attested copy of Statement of marks/passing certificate', style:'para3'},
                    // {text: 'c) ', style:'para3'},
                  {
                    text: 'Signature',
                    // bold: true,
                    fontSize: 14,
                    alignment: 'right',
                    lineHeight:2,
                    margin: [5, 75,20, 10]
                  },   
                  {text: 'The candidates applying for Migration Certificate has to pay the specified fees.',margin: [0,50,0,0], style:'foot'},     
                  {text: 'Photostat copies/ True copies should be attested by the Gazetted Officers/ self attested.', style:'foot'},
                ],
                styles :{
                  table1:{
                    fontSize:12,
                    alignment:'right',
                  },
                  para1:{
                    fontSize: 14,
                    alignment: 'left',
                    lineHeight:1,

                  },
                  para13:{
                    fontSize: 14,
                    alignment: 'left',
                    lineHeight:1.3,

                  },
                  para3:{
                    fontSize: 12,
                    alignment: 'left',
                    lineHeight:1.3,

                  },
                  para2:{
                    fontSize: 12,
                    alignment: 'left',
                    bold:true,
                  },
                  foot:{
                    fontSize: 11,
                    alignment: 'left',
                    lineHeight:1,

                  },
                  table2:{
                    fontSize:14,
                  },
                }
              };
              // (pdfMake as any).createPdf(documentDefinition).open();
              (pdfMake as any).createPdf(documentDefinition).print();
            }
          //edited ends by renuka
          
            //duplicate passing / duplicate marksheet
            else{
              const documentDefinition = { 
                header: [
                  // margin: [15, 0, 0, 10],
                 
                  // columns: [                    
                    {
                      image: await this.getBase64FromUrl('assets/img/board_logo.png'),
                     
                      width: 50,
                      height: 50,
                      margin: [0, 10, 0, 7] ,
                      alignment: 'center',
                    }                 
                  // ]
                  ],  
                content: [
                   {  //text: 'Application For '+ sessionStorage.getItem('loggedapptype')?.replace(/_+/g," "), 
                      //  image: await this.getBase64FromUrl('assets/img/board_logo.png'),
                        text: 'Acknowledgement', 
                        bold: true,
                        fontSize: 22,
                        alignment: 'center',
                        margin: [0, 20, 0, 7]
                    },     
                  {
                    text: '..................................................................................................................................................................................................................' ,
                    // bold: true,
                    fontSize: 9,
                    // alignment: 'center',
                    margin: [0, 10, 0, 7]
                  },
                  {
                    text: 'Date: '+this.datepipe.transform(new Date(), 'dd-MM-yyyy'),
                    fontSize: 12,
                    alignment: 'right',
                    margin: [5, 15, 5, 10]
                  },
                  {
                    text: 'Request for issuing '+sessionStorage.getItem('loggedapptype')?.replace(/_+/g," "),
                    bold: true,
                    fontSize: 14,
                    alignment: 'center',
                    lineHeight:2,
                    margin: [5, 15, 5, 10]
                  },
                  ,
                  {
                    text: 'Application Id:  '+this.studData.application_id,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  {
                    text: 'Payment Status:  '+this.studData.payment_status,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  {
                    text: 'Amount Paid:  Rs. '+this.studData.total_payment,
                    fontSize: 12,
                    alignment: 'left',
                  },
                  {
                    text: 'Transaction Id:  '+this.studData.transaction_id,
                    fontSize: 12,
                    alignment: 'left',
                    lineHeight:2,
                  },
                  // {text: 'To,', style:'para1'},
                  // {text: 'The Secretary', style:'para1'},
                  // {text: 'Goa Board of Secondary &', style:'para1'},
                  // {text: 'Higher Secondary Education', style:'para1'},
                  // {text: 'Alto Betim - Goa 403 521', style:'para1'},
                  // {
                  //   text: '\u200B\t\t\t I '+ this.studData.stud_name+' request you to please issue '+sessionStorage.getItem('loggedapptype')?.replace(/_+/g," ") +',  I have filled online form, and have paid fees for the same. All the nessesary documents are hereby attached with the same, (and uploaded)',
                  //   // bold: true,
                  //   fontSize: 14,
                  //   // alignment: 'center',
                  //   lineHeight:2,
                  //   margin: [5, 15, 5, 10]
                  // },
                  { 
                    layout: 'noBorders',
                    table: {
                      style:'table2',
                      widths: [250, 300],
                      //heights: [20, 20, 20,20,20,],
                      margin: [0, 5, 0, 0],
                      body: [
                        [{text:"1. Full Name",margin: [0, 5, 0, 0]},{text:this.studData.stud_name.toUpperCase( ) ,margin: [0, 5, 0, 0]}],
                        // [{text:"(begining with surname block letters)",margin: [7, 2, 0, 0]},{text:'',margin: [7, 2, 0, 0]}],
                        [{text:"2. Month & Year of passing the Examination",margin: [0, 7, 0, 0]},{text:this.studData.exam_month_year,margin: [0, 5, 0, 0]}],
                        [{text:"3. Name Of Examination",margin: [0, 7, 0, 0]}, {text: this.studData.standard,margin: [0, 5, 0, 0]}],
                        [{text:"4. Seat Number",margin: [0, 7, 0, 0]}, {text:this.studData.seat_no ,margin: [0, 7, 0, 0]}],
                        [{text:"5. School Index",margin: [0, 7, 0, 0]}, {text: this.studData.school_name,margin: [0, 5, 0, 0]}],
                        [{text:"6. Centre",margin: [0, 7, 0, 0]},{text:this.studData.exam_center,margin: [0, 5, 0, 0]}],
                        // [{text:"7. Name Of Board",margin: [0, 7, 0, 0]},{text:': _______________________________'}],
                        // [{text:"8. SCODE of the institution that sponsored the",margin: [0, 7, 0, 0]},{text:this.studData.school_name,margin: [0, 5, 0, 0]}],
                        // [{text:"candidate for above examination",margin: [7, 2, 0, 0]},{text:'',margin: [7, 2, 0, 0]}],
                        // [{text:"7. Payment Status",margin: [0, 7, 0, 0]},{text:this.studData.payment_status,margin: [0, 5, 0, 0]}],
                        [{text:"7. Mode of payment and the relavent",margin: [0, 7, 0, 0]},{text:this.paymentmode,margin: [0, 5, 0, 0]}],
                        [{text:"number of receipt / M. 0. etc.",margin: [7, 2, 0, 7]},{text:this.studData.transaction_id,margin: [0, 5, 0, 0]}]
                      ]
                    },
                    pageSize: 'A4',
                      pageOrientation: 'portrait',
                      pageMargins: 20
                    
                    },
                  {text: 'The following documents are attached herewith acknowledgement:', style:'para13'},
                  {text: 'a) An attested copy of Valid Identity Proof', style:'para3'},
                  {text: 'b) Passport sized Photo', style:'para3'},
                  {text: 'c) Request letter from school', style:'para3'},
                  // {text: 'e) Statement of Marks/ Passing Certificate', style:'para3'},
                  // {
                  //   text: '\u200B\t\t\t I also wish to state that I have cleared all my dues and payments. ',
                  //   // bold: true,
                  //   fontSize: 14,
                  //   // alignment: 'center',
                    
                  //   margin: [5, 15, 5, 10]
                  // },
                  // {
                  //   text: '\u200B\t\t\t\t\t Thanking you advance!',
                  //   // bold: true,
                  //   fontSize: 14,
                  //   // alignment: 'center',
                  //   lineHeight:2,
                  //   margin: [5, 15, 5, 10]
                  // },
                  // {
                  //   text: 'Signature',
                  //   // bold: true,
                  //   fontSize: 14,
                  //   alignment: 'right',
                  //   lineHeight:2,
                  //   margin: [5, 75, 5, 10]
                  // },
                  // {
                  //   text: '\u200B\t\t\tThis is to certify that '+ this.studData.stud_name+', Examination Seat No. '+this.studData.seat_no+'   has passed the '+ this.studexamname+' School Certificate Examination held by this Board in '+this.studData.exam_month_year+ '.',
                  //    // bold: true,
                  //   fontSize: 14,
                  //   // alignment: 'center',
                  //   lineHeight:2,
                  //   margin: [5, 25, 5, 10]
                  // },
                  // {
                  //   text: '\u200B\t\t\tThere is no objection to the candidate\'s joining an institution recognised by the Board or affiliated to a University.' ,
                  //    // bold: true,
                  //   fontSize: 14,
                  //   // alignment: 'center',
                  //   lineHeight:2,
                  //   margin: [5, 15, 5, 10]
                  // },        
                ],

                styles :{
                  table1:{
                    fontSize:12,
                    alignment:'right',
                  },
                  para1:{
                    fontSize: 14,
                    alignment: 'left',
                    lineHeight:1,

                  },
                  para13:{
                    fontSize: 14,
                    alignment: 'left',
                    lineHeight:1.3,

                  },
                  para3:{
                    fontSize: 12,
                    alignment: 'left',
                    lineHeight:1.3,

                  },
                  para2:{
                    fontSize: 12,
                    alignment: 'left',
                    bold:true,
                  },
                  foot:{
                    fontSize: 11,
                    alignment: 'left',
                    lineHeight:1,

                  },
                  table2:{
                    fontSize:14,
                  },
                }

              };
              // (pdfMake as any).createPdf(documentDefinition).open();
              (pdfMake as any).createPdf(documentDefinition).print();
              // (pdfMake as any).createPdf(documentDefinition).download('Application_Letter of '+ this.studData.stud_name+'.pdf');
            }
  }
   
   }

   getpaymentdone(){
    let merchid;
   if(this.migration){
      merchid=6080;
    }
    if(this.duplicatemarksheetpassing){
      merchid=6081;  
    }
    if(this.changerequest){
      merchid=6082;
    }

    let studdetails:{user_id:any,payment_amt:any,payment_mode:any,application_id:any,submerchantid:any,PayerName:any,email_address:any,mobile_no:any}={
      user_id:sessionStorage.getItem('loggeduserid'),
      payment_mode:this.selectedPaymentMode,
      payment_amt:this.studData.total_payment,
      application_id:this.studData.application_id,
      PayerName:this.studData.stud_name,
      submerchantid:merchid,
      email_address:this.studData.email_address,
      mobile_no:this.studData.mobile_no,
    }

   
    this.service.post('/Icicipayment/getPaymentUrl',studdetails).subscribe((res:any)=>{
      if(res.status=="success"){
          this.paymenturl=res.url;
          this.transid=res.transactionid;
          sessionStorage.setItem('flgrep','true');
          window.open(this.paymenturl,"_self");
      }
    
    });
  }
  getpaymentmode(e:any){

    this.selectedPaymentMode=e.value;
     this.isChecked2=true;
    if(this.allowRePay && this.isChecked2){
      this.isChecked=true;
    }
    else{
      this.isChecked=false;
    }
}

//place image on pdf 
getBase64FromUrl(url: any) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

       this.ctx = canvas.getContext("2d");
       this.ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("assets/img/board_logo.png");

      resolve(dataURL);
    };

    img.onerror = error => {
      reject(error);
    };

    img.src = url;
  });
}
  }


